var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('common-title-panel',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle}}),_c('div',{ref:"chart",staticStyle:{"width":"100%"},style:({ height: _vm.chartHeight + 'vh' })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }